import { render, staticRenderFns } from "./AddriskPointIdentification.vue?vue&type=template&id=a75d2862&scoped=true"
import script from "./AddriskPointIdentification.vue?vue&type=script&lang=js"
export * from "./AddriskPointIdentification.vue?vue&type=script&lang=js"
import style0 from "./AddriskPointIdentification.vue?vue&type=style&index=0&id=a75d2862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75d2862",
  null
  
)

export default component.exports